import { render, staticRenderFns } from "./StrockTransToMarketplace.vue?vue&type=template&id=04cd3911&"
import script from "./StrockTransToMarketplace.vue?vue&type=script&lang=js&"
export * from "./StrockTransToMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./StrockTransToMarketplace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports